import type { Feature } from '@luna/gatekeeper';

export const creditCardDirectDebit: Feature = {
    enabled: false,
    _description: 'Enables sepa direct debit menu item in the credit card side menu',
};
